import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { AuthService } from '../../../../_auth/auth.service';
import { KCACTION } from '../../../../_constants/keycloak';
import { roles } from '../../../../_constants/roles';
import { USER_PROFILE } from '../../../../_models/user.model';
import { AppSettingService } from '../../../../_services/_appSetting/app-setting.service';
import { LocalService } from '../../../../_services/_storage/local.service';
import { UserService } from '../../../../_services/_user/user.service';
import { SnackbarService } from '../../../../_services/snackbar/snackbar.service';

@Component({
    selector: 'lokos-profile',
    templateUrl: './profile.component.html',
    styleUrl: './profile.component.scss',
    standalone: false
})
export class ProfileComponent implements OnInit, OnDestroy {
    userRoles: string[] | any;
    userProfile: USER_PROFILE | any;

    isTOTPConfigured = false;
    isPasswordLessAuthConfigured = false;
    currentTheme = '';
    subscriptions: Subscription[] = [];


    private router = inject(Router);

    constructor (
        private localService: LocalService,
        private auth: AuthService,
        private _user: UserService,
        private snackbarService: SnackbarService,
        private appSettingService: AppSettingService
    ) { }

    ngOnInit (): void {
        this.getUserCredentials();
        this.userRoles = this.localService.get('userRoles') || [];
        this.filterUserRoles();
        this.userProfile = this.localService.get('userProfile') || {};
        const theme = this.appSettingService.appTheme$.subscribe((theme) => {
            this.currentTheme = theme;
        });

        this.subscriptions.push(theme);
    }

    getUserCredentials () {
        this._user.getUserCredentials(this.auth.getUserGUID()).subscribe({
            next: (res: any) => {
                res.forEach((auth: any) => {
                    if (auth.type === 'otp') {
                        this.isTOTPConfigured = !!auth.userCredentialMetadatas.length;
                    }
                    if (auth.type === 'webauthn-passwordless') {
                        this.isPasswordLessAuthConfigured =
                            !!auth.userCredentialMetadatas.length;
                    }
                });
            },
            error: (error: any) => {
                this.snackbarService.errorSnackbar(
                    error.error.message || error.message
                );
            }
        });
    }

    filterUserRoles () {
        this.userRoles = (Object.values(roles) as string[]).filter((role: any) =>
            this.userRoles.includes(role)
        );
    }

    /**
   * Logout
   */
    logout () {
        this.auth.logout();
    }

    onAction (type: string) {
        const url = `${environment.keycloak.issuer}realms/lokos/protocol/openid-connect/auth`;
        const queryParams: any = {
            response_type: 'code',
            client_id: environment.keycloak.clientId,
            scope: environment.keycloak.scope,
            redirect_uri: window.location.href
        };

        if (type === 'changePassword') {
            queryParams['kc_action'] = KCACTION.UPDATE_PASSWORD;
        } else if (type === 'totp') {
            queryParams['kc_action'] = KCACTION.UPDATE_TOTP;
        } else if (type === 'email') {
            queryParams['kc_action'] = KCACTION.UPDATE_EMAIL;
        } else if (type === 'passwordLess') {
            queryParams['kc_action'] = KCACTION.WEB_AUTH_PASSWORDLESS;
        }
        const queryString = new URLSearchParams(queryParams).toString();
        this.navigateTo(`${url}?${queryString}`);
    }

    navigateTo (url: string) {
        window.location.assign(url);
    }

    openRoleRequest () {
        this.router.navigate(['/main/role-request']);
    }

    ngOnDestroy (): void {
        this.subscriptions.forEach((sub: Subscription) => {
            sub.unsubscribe();
        });
    }
}
